import { Drawer } from 'vaul';
import { MIcon } from '../../lib/micon';
import './LdSheet.css';
import '../ld/ld-fenster.css';

interface LdSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  maxWidth?: number;
  ariaLabel?: string;
  fullscreen?: boolean;
  /** Welle K4: gemeinsamer Fenster-Rahmen — Titel, Kontextzeile (Kind, Klasse), Symbol, runder Schließen-Knopf */
  kopf?: { titel: string; kontext?: string | null; icon?: string };
  /** Welle K4: feste Fußleiste (Abbrechen + eine Hauptaktion, siehe LdFensterFuss) */
  fuss?: React.ReactNode;
}

// Handy: Sheet von unten. PC: zentrierter Dialog (höchstens 620 px, LdSheet.css).
export function LdSheet({
  open,
  onClose,
  children,
  title,
  maxWidth,
  ariaLabel,
  fullscreen = false,
  kopf,
  fuss,
}: LdSheetProps) {
  // Welle K4: ein sichtbarer Titel bekommt immer den gemeinsamen Kopf (runder Schließen-Knopf)
  if (!kopf && title) kopf = { titel: title };
  return (
    <Drawer.Root open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <Drawer.Portal>
        <Drawer.Overlay className="ld-ldsheet-overlay" />
        <Drawer.Content
          className={`ld-ldsheet${fullscreen ? ' ld-ldsheet--fullscreen' : ''}${kopf ? ' ld-ldsheet--rahmen' : ''}`}
          style={maxWidth ? ({ '--ld-sheet-max-width': `${maxWidth}px` } as React.CSSProperties) : undefined}
          aria-label={ariaLabel ?? kopf?.titel}
          aria-describedby={undefined}
        >
          <Drawer.Handle />
          {kopf ? (
            <div className="ld-fe-kopf">
              {kopf.icon && <span className="ld-fe-kopf__icon" aria-hidden="true"><MIcon name={kopf.icon} size={20} /></span>}
              <div className="ld-fe-kopf__text">
                <Drawer.Title className="ld-fe-kopf__titel">{kopf.titel}</Drawer.Title>
                {kopf.kontext && <p className="ld-fe-kopf__kontext">{kopf.kontext}</p>}
              </div>
              <button type="button" className="ld-fe-zu" aria-label="Schließen" onClick={onClose}><MIcon name="close" size={20} /></button>
            </div>
          ) : title ? (
            <Drawer.Title className="ld-ldsheet-title">{title}</Drawer.Title>
          ) : (
            // Welle U6b: Dialoge brauchen einen Titel (Screenreader) — unsichtbar, wenn keiner sichtbar ist
            <Drawer.Title className="ld-ldsheet-srtitle">{ariaLabel ?? 'Dialog'}</Drawer.Title>
          )}
          <div className={`ld-ldsheet-body${kopf ? ' ld-fe-inhalt' : ''}`}>
            {children}
          </div>
          {fuss && <div className="ld-fe-fuss">{fuss}</div>}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
